export default __webpack_public_path__ + "static/media/aroma7.1a526921.png";